import { useParams } from 'react-router';

import { useGetSchoolDataQuery } from '@/api/endpoints/schools';
import { FetchDataWrapper } from '@/shared/components';
import type { ESchoolSubsection } from '@/shared/types';

import { SchoolAbilitiesSubsection } from './SchoolAbilitiesSubsection/SchoolAbilitiesSubsection';
import { SchoolFAQSubsection } from './SchoolFAQSubsection/SchoolFAQSubsection';
import { SchoolProgramSubsection } from './SchoolProgramSubsection/SchoolProgramSubsection';
import { SchoolSpeakersSubsection } from './SchoolSpeakersSubsection/SchoolSpeakersSubsection';

type TProps = {
  type: ESchoolSubsection;
};

const SUBSECTION_TYPE_TO_COMPONENT_MAPPER = {
  faq: SchoolFAQSubsection,
  abilities: SchoolAbilitiesSubsection,
  speakers: SchoolSpeakersSubsection,
  program: SchoolProgramSubsection,
};

export const SchoolSubsectionPage = ({ type }: TProps) => {
  const { id: schoolId } = useParams();

  const {
    data: schoolData,
    isLoading: isSchoolDataLoading,
    isError: isSchoolDataFetchError,
  } = useGetSchoolDataQuery({ id: Number(schoolId) });

  return (
    <FetchDataWrapper
      isLoading={isSchoolDataLoading}
      isError={isSchoolDataFetchError}
    >
      {schoolData &&
        (() => {
          const Component = SUBSECTION_TYPE_TO_COMPONENT_MAPPER[type];

          return (
            <Component
              id={schoolData.id}
              name={schoolData.name}
            />
          );
        })()}
    </FetchDataWrapper>
  );
};
